// This is a generated file. Any changes made directly in this file will be overwritten.
import * as React from 'react';
import { createSvgIcon } from '@bb-ui/react-library/dist/internal/icons';

export const GoogleDrive = createSvgIcon(
  { LeftToRight: <React.Fragment><g fill="currentColor" stroke="transparent"><path d="M3.636 14.9014l2.6227-4.496H16l-2.248 4.496H3.636zM16 9h-5.058L5.8841 1h5.0579L16 9zM4.4958 1.4133L7.078 5.9326l-4.8307 8.9688-2.248-4.496 4.4964-8.992z" /></g><defs></defs></React.Fragment>, },
  'small'
);
